import React, { useContext, useState } from 'react';
import {
  CardContainer,
  InformationContainer,
  InformationField,
  ButtonExpand,
} from './styles';
import ArrowIconSrc from '../../../../assets/icones/arrow_up.svg';
import { ReactComponent as StickyNoteIcon } from '../../../../assets/novosicones/Solicitacoes/sticky_note_2_black_24dp (1).svg';
import { ReactComponent as EventIcon } from '../../../../assets/novosicones/Solicitacoes/event_black_24dp.svg';

import { ReactComponent as HomeIcon } from '../../../../assets/novosicones/Solicitacoes/home.svg';
import { ContextSolicitacoes } from '../../../../services/solicitacoes';
import { ContextoListaApartamentos } from '../../../ApartamentList/contextoImoveis';

import handleSubGrupoName from '../../../../Utils/handleSubGrupoName';

import formatDate from '../../../../Utils/formatDate';
import { ContextSindico } from '../../../../services/sindico';
import { handleDateOtherTypesSolicitation } from '../functions';
// import horario from "../../horario";

const CardSolicitacaoMobile = (props) => {
  const { getSolicitacaoUnica } = useContext(
    props?.isSindico ? ContextSindico : ContextSolicitacoes
  );

  const { tema } = useContext(ContextoListaApartamentos);

  let color = {};

  const isShowBackgroundPrimary =
    props?.item?.status === 'Em aberto' ||
    props?.item?.status === 'Em andamento' ||
    props?.item?.status === 'Em atendimento';

  if (isShowBackgroundPrimary) {
    color = { bg: tema.primaryColorFade, colorText: tema.primaryColor };
  } else {
    color = {
      bg: 'rgba(132, 132, 132, 0.4)',
      colorText: 'rgba(132, 132, 132)',
    };
  }
  const requestDateTime = () => {
    let fusoHorario = new Date().getTimezoneOffset();
    let requestTime = new Date(props?.item?.dataAgendamento);
    const dataAgendamento = props?.item?.dataAgendamento;
    const dataAgendamentoFinal = props?.item?.dataAgendamentoFinal;
    requestTime.setMinutes(fusoHorario);

    if (
      props?.item?.tipo === 'Assistência Técnica' &&
      requestTime.getHours() < 12
    ) {
      return `${formatDate(dataAgendamento)} 
      - Manhã`;
    } else if (
      props?.item?.tipo === 'Assistência Técnica' &&
      requestTime.getHours() >= 12
    ) {
      return `${formatDate(dataAgendamento)} 
      - Tarde`;
    } else {
      return handleDateOtherTypesSolicitation(
        dataAgendamento,
        dataAgendamentoFinal
      );
    }
  };

  const [showCardInfos, setShowCardInfos] = useState(false);
  const toggleCardInfos = () => {
    setShowCardInfos(!showCardInfos);
  };

  const isFirstElement = props.index === 0;

  return (
    <>
      {isFirstElement && <span>Title</span>}
      <CardContainer color={color} tema={tema?.primaryColor}>
        <div className='headerSolicitacao'>
          <div className='containerProtocoloClassificacao'>
            <ButtonExpand
              onClick={toggleCardInfos}
              isShowingCardInfos={showCardInfos}
            >
              <img src={ArrowIconSrc} />
            </ButtonExpand>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span
                className='solicitacaocaseNumber'
                onClick={() => getSolicitacaoUnica(props.item.id)}
              >
                {props?.item?.caseNumber}
              </span>
              <span className='tipoSolicitacao'>
                {handleSubGrupoName(props?.item?.tipo)}
              </span>
            </div>
          </div>
          <div className='solicitacaostatus containerItem'>
            <button
              className='centralized'
              onClick={() => getSolicitacaoUnica(props.item.id)}
            >
              {(props?.item?.status === 'Cancelado' ||
                props?.item?.status === 'Fechado') &&
                'Concluído'}
              {props?.item?.status === 'Em atendimento' && 'Em andamento'}
              {props?.item?.status !== 'Cancelado' &&
                props?.item?.status !== 'Em atendimento' &&
                props?.item?.status !== 'Fechado' &&
                props?.item?.status}
            </button>
          </div>
        </div>
        {showCardInfos && (
          <InformationContainer>
            <InformationField>
              <span className='title'>Abertura</span>
              <div className='valueContainer'>
                <span className='value'>
                  {formatDate(props?.item?.dataCriacaoSolicitacao) ??
                    '--/--/----'}
                </span>

                <StickyNoteIcon />
              </div>
            </InformationField>
            <InformationField>
              <span className='title'>Agendamento</span>
              <div className='valueContainer'>
                <span className='value'>
                  {props?.item?.dataAgendamento
                    ? requestDateTime()
                    : 'Não elegível'}
                </span>
                <EventIcon />
              </div>
            </InformationField>
            <InformationField>
              <span className='title'>Contrato</span>

              <div className='valueContainer'>
                <span className='value'>{props?.item?.ativo}</span>
                <HomeIcon />
              </div>
            </InformationField>
            <span
              className='acompanharSolicitacao'
              onClick={() => getSolicitacaoUnica(props.item.id)}
            >
              Acompanhar Solicitação{' '}
            </span>
          </InformationContainer>
        )}
      </CardContainer>
    </>
  );
};

export default CardSolicitacaoMobile;
